import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { LocationService } from 'app/masters/location-master/location.service';
import { Observable } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { AuthService } from 'app/auth/auth.service';
import { ExportService } from 'app/reports/services/export.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { ratelistModal , ratelistdataModal } from 'app/masters/models/service-master.model';
import { MatDialog } from '@angular/material/dialog';
import { ExcelRecoveryManagerComponent } from 'app/billing/excel-recovery-manager/excel-recovery-manager.component';
import { ExcelRateListComponent } from './excel-ratelist/excel-ratelist.component';

@Component({
  selector: 'app-rate-list-master',
  templateUrl: './rate-list-master.component.html',
  styleUrls: ['./rate-list-master.component.scss']
})
export class RateListMasterComponent implements OnInit {
  displayedColumns: string[] = ['branchName', 'rateListName', 'startDate' ,'validUpto', 'isActive'];
  columnNames: string[] = ['General','Semi Pvt.','Pvt.','Semi Deluxe','Deluxe','Ser. Charge','Disc. Type','Disc. Percent','Max. Disc'];
  selectedColumnName: string | null = null;
  dataSource = new MatTableDataSource<any>();
  ratelistControl: FormControl;
  branchlistControl: FormControl;
  categoryControl: FormControl;
  deparatmentControl: FormControl;
  serviceControl: FormControl;
  ratelistData: any[] = [];
  branchList: any[] = [];
  categoryList: any[] = [];
  departmentList: any[] = [];
  serviceActiveArray: any[] = [];
  filteredratelistArray: Observable<any[]>;
  filteredbranchArray: Observable<any[]>;
  filteredcategoryArray: Observable<any[]>;
  filtereddepartmentArray: Observable<any[]>;
  filteredServiceArray: Observable<any[]>;
  serviceData: ratelistdataModal[] = [];
  holdserviceData: ratelistdataModal[] = [];
  getRecoveryManager: any[] = [];
  selectedType: string = '';
  inputValue: string = '';
  ratelistmodal: ratelistModal = {};
  selectedServiceId: string;
  searchValue: string = '';
  searchValues : string = '';
  showSpinner: boolean = false;

  constructor(
    public locationService: LocationService,
    public authservice: AuthService,
    private fb: FormBuilder,
    private exportdata: ExportService,
    public branchmasterService: BranchMatserService,
    public dialog: MatDialog 
  ) {}

  ngOnInit(): void {
    this.getrateList(0, this.authservice.Loggeduser.specialityId);
    this.getBranch();
    this.getcategoryList();
    this.getdepartmentList();
    this.getserviceData(0);
    this.dataSource.filterPredicate = this.createFilter();
    this.ratelistmodal.StartDate = new Date();
    this.ratelistmodal.Validupto = new Date();
    this.ratelistmodal.IsActive = true;
  }

  openexcelRecovery() {
    this.getRecoveryManager = [];
    const dialogRef = this.dialog.open(ExcelRateListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      maxHeight: '86%',
      width: '80%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.length > 0) {
        this.getRecoveryManager = result;
        this.CheckALlcolorCoding(this.getRecoveryManager);
        const excelRows = this.transformExcelToRateData(result);
        this.serviceData = excelRows;
        this.holdserviceData = [...excelRows];
        this.getRecoveryManager = result;
        this.CheckALlcolorCoding(this.getRecoveryManager);
      }
    });
  }

  private transformExcelToRateData(excelData: any[]): any[] {
    return excelData.map((row) => ({
      serviceName: row.serviceName,
      PK_RLDetailId: 0,
      FK_ServiceId: row.serviceId,
      RateGeneral: row.general,
      RateSemiPrivate: row.semiPvt,
      RatePrivate: row.pvt,
      RateSemiDelux: row.semiDeluxe,
      RateDelux: row.deluxe,
      Discount: row.discPercent,
      MaxDiscountLimit: row.maxDisc,
      ServiceCharge: row.serviceCharge,
      IsActive: true,
      DiscountType: row.discType,
      IsEdit: false,
      IsDelete: false,
      serviceCode: row.code
    }));
  }
  

  CheckALlcolorCoding(recoveryData: any[]) {
  }
  editColumnWiseModal() {
    document.getElementById('editColumnWiseModal').style.display = 'block';
  }

  closeEditColumnWiseModal() {
    document.getElementById('editColumnWiseModal').style.display = 'none';
    this.selectedColumnName = '';
    this.selectedType = '';
    this.inputValue = '';
  }

  columnMapping = {
    'General': 'RateGeneral',
    'Semi Pvt.': 'RateSemiPrivate',
    'Pvt.': 'RatePrivate',
    'Semi Deluxe': 'RateSemiDelux',
    'Deluxe': 'RateDelux',
    'Ser. Charge': 'ServiceCharge',
    'Disc. Type': 'DiscountType',
    'Disc. Percent': 'Discount',
    'Max. Disc': 'MaxDiscountLimit'
  };

  updateColumnValues() {
    const colKey = this.columnMapping[this.selectedColumnName];
    if (!colKey) return;
    for (let row of this.serviceData) {
      if (row[colKey] === 0 || row[colKey] === null ||row[colKey] == "0") {
        row[colKey] = this.inputValue;
      }
    }
    this.closeEditColumnWiseModal();
  }

  searchRecordModal() {
    document.getElementById('searchRecordModal').style.display = 'block';
    this.getrateList(0, this.authservice.Loggeduser.specialityId);
  }

  closeSearchRecordModal() {
    document.getElementById('searchRecordModal').style.display = 'none';
    this.searchValue = ''; 
    this.dataSource.filter= ''
  }

  applyRateListFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.rateListName?.toLowerCase().includes(transformedFilter) ||
        data.branchName?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? 'active' : 'inactive').includes(transformedFilter)
      );
    };
  }

  getrateList(id: any, id1: any): void {
    this.locationService.getrateList(id, id1).subscribe((ratelist: any[]) => {
      this.dataSource.data = ratelist;
      this.ratelistData = ratelist;
      this.initializeratelistControl();
    });
  }

  initializeratelistControl() {
    this.ratelistControl = new FormControl();
    this.filteredratelistArray = this.ratelistControl.valueChanges.pipe(
      startWith(''),
      map((ratelist) =>
        ratelist
          ? this.filterratelistFunction(ratelist)
          : this.ratelistData.slice()
      )
    );
  }

  filterratelistFunction(name: string): any[] {
    return this.ratelistData.filter((ratelist) =>
      ratelist.rateListName.toLowerCase().includes(name.toLowerCase())
    );
  }

  apptexportexcel(): void {
    let element = document.getElementById('contentappd');
    this.exportdata.exportxcel(element);
  }

  getBranch() {
    this.locationService.getallBranches().subscribe((branch: any[]) => {
      this.branchList = branch;
      this.initializebranchControl();
    });
  }

  initializebranchControl() {
    this.branchlistControl = new FormControl();
    this.filteredbranchArray = this.branchlistControl.valueChanges.pipe(
      startWith(''),
      map((branchList) =>
        branchList
          ? this.filterbranchlistFunction(branchList)
          : this.branchList.slice()
      )
    );
  }

  filterbranchlistFunction(name: string): any[] {
    return this.branchList.filter((b) =>
      b.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }

  getcategoryList() {
    this.branchmasterService.getCategorybyServiceList(this.authservice.Loggeduser.specialityId).subscribe((item: any) => {
      this.categoryList = item;
      this.initializecategoryList();
    });
  }

  initializecategoryList() {
    this.categoryControl = new FormControl();
    this.filteredcategoryArray = this.categoryControl.valueChanges.pipe(
      startWith(''),
      map((categoryList) =>
        categoryList ? this.filtercategoryFunction(categoryList) : this.categoryList.slice()
      )
    );
  }

  filtercategoryFunction(name: string): any {
    return this.categoryList.filter((cat) =>
      cat.categoryName.toLowerCase().includes(this.categoryControl.value.toLowerCase())
    );
  }

  getdepartmentList() {
    this.branchmasterService.getServiceDepartmentMaster(this.authservice.Loggeduser.specialityId).subscribe((item: any) => {
      this.departmentList = item;
      this.initializedepratmentControl();
    });
  }

  initializedepratmentControl() {
    this.deparatmentControl = new FormControl();
    this.filtereddepartmentArray = this.deparatmentControl.valueChanges.pipe(
      startWith(''),
      map((departmentList) =>
        departmentList ? this.filterdepartmentFunction(departmentList) : this.departmentList.slice()
      )
    );
  }

  filterdepartmentFunction(name: string): any {
    return this.departmentList.filter((dept) =>
      dept.deptName.toLowerCase().includes(this.deparatmentControl.value.toLowerCase())
    );
  }

  getserviceData(id: number) {
    this.branchmasterService
      .getServicemaster(id, this.authservice.Loggeduser.specialityId)
      .subscribe(
        (item: any[]) => {
          this.serviceActiveArray = item.filter((x: any) => x.isActive === true);
          this.initializeServiceControl();
        },
        (err) => {
          console.error('Error fetching service data:', err);
        }
      );
  }

  initializeServiceControl() {
    this.serviceControl = new FormControl();
    this.filteredServiceArray = this.serviceControl.valueChanges.pipe(
      startWith(''),
      map((service) =>
        service
          ? this.filterServiceFunction(service)
          : this.serviceActiveArray.slice()
      )
    );
  }

  filterServiceFunction(name: string): any[] {
    return this.serviceActiveArray.filter((service) =>
      service.serviceName.toLowerCase().includes(name.toLowerCase())
    );
  }


  onDepartmentChange(event: any): void {
    if(event.option.id > 0){
     this.categoryList = this.categoryList.filter(
       (category) => category.fk_DeptId === event.option.id && category.isActive
     );
     this.initializecategoryList(); 

     this.serviceActiveArray = this.serviceActiveArray.filter(
      (service) => service.fk_DeptId === event.option.id && service.isActive
    );
    this.initializeServiceControl(); 
    }
   }
   onCategoryChange(event: any): void {
    if(event.option.id > 0){
     this.serviceActiveArray = this.serviceActiveArray.filter(
       (service) => service.fK_CategoryId === event.option.id && service.isActive
     );
     this.initializeServiceControl(); 
    }
   }

  applyServiceFilter(searchValue: string): void {
    if (!this.holdserviceData || this.holdserviceData.length === 0) {
      return;
    }
    if (!searchValue) {
      this.serviceData = [...this.holdserviceData];
      return;
    }

    const filterText = searchValue.toLowerCase();
    this.serviceData = this.holdserviceData.filter((item) => {
      const nameMatch = item.serviceName?.toLowerCase().includes(filterText);
      const codeMatch = item.serviceCode?.toString().toLowerCase().includes(filterText);
      return nameMatch || codeMatch;
    });
  }

  loadallServices(id: number) {
    this.showSpinner = true
    this.serviceData = []; 
    this.branchmasterService
      .getServicemaster(id, this.authservice.Loggeduser.specialityId)
      .subscribe(
        (services: any[]) => {
          const activeServices = services.filter((service) => service.isActive);
          const loadedServices = activeServices.map((service) => ({
            PK_RLDetailId: service.pK_RLDetailId || 0,
            FK_ServiceId: service.pK_ServiceId || 0,
            RateGeneral: service.rateGeneral || 0,
            RateSemiPrivate: service.rateSemiPrivate || 0,
            RatePrivate: service.ratePrivate || 0,
            RateSemiDelux: service.rateSemiDelux || 0,
            RateDelux: service.rateDelux || 0,
            Discount: service.discount || 0,
            MaxDiscountLimit: service.maxDiscountLimit || 0,
            ServiceCharge: service.serviceCharge || 0,
            IsActive: service.isActive,
            DiscountType: service.discountType || 0,
            IsEdit: false,
            IsDelete: false,
            serviceName: service.serviceName,
            serviceCode: service.serviceCode || null,
          }));

          this.serviceData = loadedServices;
          this.holdserviceData = [...loadedServices];
          this.showSpinner = false
        },
        (err) => {
          console.error('Error fetching service data:', err);
          this.showSpinner = false
        }
      );
  }

  onbranchSelected(branch: any) {
    const selectedBranch = this.branchList.find((b: any) => b.branchName == branch);
    if (selectedBranch) {
      this.ratelistmodal.branchName = selectedBranch.branchName;
      this.ratelistmodal.FK_BranchId = selectedBranch.pkBranchId;
    }
  }

  onbranchChange(event:KeyboardEvent){
    const branchValue = (event.target as HTMLInputElement).value
    if (branchValue == ''){
      this.ratelistmodal.FK_BranchId = null;
    }
  }
  deptClear(event :KeyboardEvent){
    const deptvalue = (event.target as HTMLInputElement).value
    if (deptvalue == ''){
      this.getserviceData(0);    
    }

  }
  searchModal() {
    document.getElementById('serviceModal').style.display = 'block';
  }

  closeSearchModal() {
    document.getElementById('serviceModal').style.display = 'none';
  }

  onServiceSelected(serviceId: string): void {
    this.selectedServiceId = serviceId;
    this.searchModal();
  }

  onModalYes() {
    if (!this.selectedServiceId) {
      return;
    }
    const idToCheck = Number(this.selectedServiceId);
    const duplicate = this.holdserviceData.some(
      (item) => item.FK_ServiceId == idToCheck
    );
  
    if (duplicate) {
      this.locationService.openSnackBar('This service already exists in the list.','OK' );
      this.closeSearchModal()
      return; 
    }
  
    this.addServiceToRateList(this.selectedServiceId);
    this.closeSearchModal();
    this.serviceControl.setValue('');
  }
  
  addServiceToRateList(serviceId: string): void {
    this.branchmasterService
      .getServicemaster(serviceId, this.authservice.Loggeduser.specialityId)
      .subscribe(
        (services: any[]) => {
          const activeServices = services.filter((service) => service.isActive);
            services.forEach((service) => {
              this.serviceData.push({
                PK_RLDetailId: service.pK_RLDetailId || 0,
                FK_ServiceId: service.pK_ServiceId || 0,
                RateGeneral: service.rateGeneral ||0,
                RateSemiPrivate: service.rateSemiPrivate || 0,
                RatePrivate: service.ratePrivate || 0,
                RateSemiDelux: service.rateSemiDelux || 0,
                RateDelux: service.rateDelux || 0,
                Discount: service.discount || 0,
                MaxDiscountLimit: service.maxDiscountLimit || 0,
                ServiceCharge: service.serviceCharge || 0,
                IsActive: service.isActive,
                DiscountType: service.discountType || 0,
                IsEdit: (service.pK_RLDetailId || 0) > 0,               
                IsDelete: false,
                serviceName: service.serviceName,
                serviceCode: service.serviceCode
              });
            });
          this.holdserviceData = [...this.serviceData];
        },
        (err) =>
           { console.error('Error fetching service data', err);  }
      );
    this.selectedServiceId = null;
  }

  saveratelistMaster(event:any) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    if (this.ratelistmodal.StartDate > this.ratelistmodal.Validupto) {
      this.locationService.openSnackBar('Valid Upto date should be greater than or equal to Start Date','OK');
      return;
    }
    const branch = this.branchList.find(item => item.branchName == this.ratelistmodal.branchName );
    if (branch) {
      this.ratelistmodal.branchName = branch.branchName;
    }else {
      this.locationService.openSnackBar("Please select a valid Branch", "OK");
      return;
    }

    if (!this.ratelistmodal.PK_RateListId) {
      if (this.searchValues.length > 0) {
        for (let i = 0; i < this.serviceData.length; i++) {
          this.holdserviceData = this.holdserviceData.filter(item => item.FK_ServiceId !== this.serviceData[i].FK_ServiceId)
        }
        this.serviceData = this.serviceData.concat(this.holdserviceData)
      }
      const existingRateList = this.ratelistData.find(
        (rateList) =>rateList.rateListName.toLowerCase() === this.ratelistmodal.ratelistName?.toLowerCase());

      if (existingRateList) {
        this.locationService.openSnackBar('Already exists in the list', 'OK');
        this.clearForm();
        return;
      }
      this.showSpinner = true
      const payload = {
        InsertRateListMasterDto: {
          PK_RateListId: this.ratelistmodal.PK_RateListId ? this.ratelistmodal.PK_RateListId : 0,
          FK_BranchId: this.ratelistmodal.FK_BranchId,
          RateListName: this.ratelistmodal.ratelistName,
          StartDate: this.ratelistmodal.StartDate,
          Validupto: this.ratelistmodal.Validupto,
          IsActive: this.ratelistmodal.IsActive ? this.ratelistmodal.IsActive : false,
          Fk_SpecialityIdModule: this.authservice.Loggeduser.specialityId,
          IsEdit: false
        },
        InsertRateListDetailDto: this.serviceData.concat(this.getdeleteservice)
      };

      this.locationService.InsertRateListMaster(payload).subscribe(
        (response: any) => {
          this.locationService.openSnackBar('Record saved successfully', 'OK');
          this.getrateList(0, this.authservice.Loggeduser.specialityId);
          this.clearForm();
          this.serviceData = [];
          this.getdeleteservice=[]
          this.searchValues=''
          this.showSpinner = false
          button.removeAttribute('disabled');
        },
        err => {
          if (err.status == 403) {
            this.locationService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.locationService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.locationService.openSnackBar("API Failed", "OK");
          }
          this.searchValues=''
          this.showSpinner = false
          button.removeAttribute('disabled');

        }
      );
    } else {
      this.showSpinner = true
      const payload = {
        InsertRateListMasterDto: {
          PK_RateListId: this.ratelistmodal.PK_RateListId ? this.ratelistmodal.PK_RateListId: 0,
          FK_BranchId: this.ratelistmodal.FK_BranchId,
          RateListName: this.ratelistmodal.ratelistName,
          StartDate: this.ratelistmodal.StartDate,
          Validupto: this.ratelistmodal.Validupto,
          IsActive: this.ratelistmodal.IsActive ? this.ratelistmodal.IsActive : false,
          Fk_SpecialityIdModule: this.authservice.Loggeduser.specialityId,
          IsEdit: true
        },
        InsertRateListDetailDto:  this.serviceData.concat(this.getdeleteservice)
      };

      this.locationService.InsertRateListMaster(payload).subscribe(
        (response: any) => {
          this.locationService.openSnackBar('Record updated successfully', 'OK');
          this.getrateList(0, this.authservice.Loggeduser.specialityId);
          this.clearForm();
          this.serviceData = [];
          this.getdeleteservice=[]
          this.searchValues=''
          this.showSpinner = false
          button.removeAttribute('disabled');
        },
        err => {
          if (err.status == 403) {
            this.locationService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.locationService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.locationService.openSnackBar("API Failed", "OK");
          }
          this.searchValues=''
          this.showSpinner = false
          button.removeAttribute('disabled');
        }
      );
    }
  }

  onRowDoubleClick(row: any) {
    this.ratelistmodal.ratelistName = row.rateListName;
    this.ratelistmodal.IsActive = row.isActive;
    this.ratelistmodal.Validupto = row.validupto;
    this.ratelistmodal.StartDate = row.startDate;
    this.ratelistmodal.branchName = row.branchName;
    this.ratelistmodal.PK_RateListId = row.pK_RateListId;
    this.ratelistmodal.FK_BranchId = row.fK_BranchId;
    this.closeSearchRecordModal();
    this.onratelistSelected(row.pK_RateListId, 0);
  }

  clearForm() {
    this.ratelistmodal.ratelistName = '';
    this.ratelistmodal.IsActive = false;
    this.ratelistmodal.StartDate = new Date();
    this.ratelistmodal.Validupto = new Date();
    this.ratelistmodal.branchName = '';
    this.ratelistmodal.PK_RateListId = 0;
    this.serviceData = [];
    this.holdserviceData = []; 
    this.ratelistControl.setValue('');
    this.serviceControl.setValue('');
    this.deparatmentControl.setValue('');
    this.categoryControl.setValue('');
    this.closeSearchModal;
    this.ratelistmodal.IsActive = true;
    this.getserviceData(0)
    this.searchValues= ''
  }

  editService(service: any) {
    service.isEdit = true;
  }

  saveService(service: any) {
    service.isEdit = false;
  }

  getdeleteservice : ratelistdataModal[] = [];
  deleteService(service: any) {
    const index = this.serviceData.indexOf(service);
    if (index > -1) {
      this.serviceData.splice(index, 1);
      this.getdeleteservice.push(service);
      this.getdeleteservice.map(item => item.IsDelete = true);
    }
    this.holdserviceData = [...this.serviceData];
  }

  onratelistSelected(event: any, type: any) {
    this.showSpinner = true
    this.serviceData = [];
    this.holdserviceData = [];
    this.locationService.getserviceByDepartmentId(0, 0, event, 0).subscribe(
      (services: any[]) => {
        if (services.length > 0 && type === 0) {
          services.forEach((service) => {
            this.serviceData.push({
              PK_RLDetailId: service.pK_RLDetailId,
              FK_ServiceId: service.serviceId,
              RateGeneral: service.rateGeneral,
              RateSemiPrivate: service.rateSemiPrivate,
              RatePrivate: service.ratePrivate,
              RateSemiDelux: service.rateSemiDelux,
              RateDelux: service.rateDelux,
              Discount: service.discount,
              MaxDiscountLimit: service.maxDiscountLimit,
              ServiceCharge: service.serviceCharge,
              IsActive: service.isActive,
              DiscountType: service.discountType,
              IsEdit: true,
              IsDelete: false,
              serviceName: service.serviceName,
              serviceCode: service.serviceId
            });
          });
          this.showSpinner = false
        } else {
          services.forEach((service) => {
            this.serviceData.push({
              PK_RLDetailId: 0,
              FK_ServiceId: service.serviceId,
              RateGeneral: service.rateGeneral,
              RateSemiPrivate: service.rateSemiPrivate,
              RatePrivate: service.ratePrivate,
              RateSemiDelux: service.rateSemiDelux,
              RateDelux: service.rateDelux,
              Discount: service.discount,
              MaxDiscountLimit: service.maxDiscountLimit,
              ServiceCharge: service.serviceCharge,
              IsActive: service.isActive,
              DiscountType: service.discountType,
              IsEdit: false,
              IsDelete: false,
              serviceName: service.serviceName,
              serviceCode: service.serviceId
            });
          });
          this.showSpinner = false
        }

        this.holdserviceData = [...this.serviceData];
        this.showSpinner = false
      },
      (err) => {
        console.error('Error fetching service data:', err);
        this.showSpinner = false
      }
    );
  }

  validateDiscount(service: any): void {
    if (service.DiscountType == 'P' && +service.Discount > 100) {
      service.Discount = 100; 
      this.locationService.openSnackBar('Discount percentage cannot exceed 100% for percentage type.' , "OK");
    }
  } 
}
